import { FilterField, labelId } from "kontrolEdge/helpers/advancedFilters";
import { HealthCheckItem } from "./HealthCheckData";

export function makeHealthCheckFields(): FilterField<HealthCheckItem>[] {
  const fields: FilterField<HealthCheckItem>[] = [
    {
      label: "Name",
      key: "name",
      accessor: (r) => r.name,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Status",
      key: "status",
      accessor: (r) => r.mainStatus || "",
      type: "string",
      inFreeText: true,
    },
    {
      label: "Description",
      key: "description",
      accessor: (r) => r.description || "",
      type: "string",
      inFreeText: true,
    },
    {
      label: "ID",
      key: "id",
      accessor: (r) => r.id,
      type: "string",
      inFreeText: true,
    },
    {
      label: "CPU",
      key: "cpu",
      accessor: (r) => (r.cpu ? r.cpu.toString() : ""),
      type: "string",
      inFreeText: true,
    },
    {
      label: "RAM",
      key: "ram",
      accessor: (r) => (r.ram ? r.ram.toString() : ""),
      type: "string",
      inFreeText: true,
    },
    {
      label: "Storage",
      key: "storage",
      accessor: (r) => (r.storage ? r.storage.toString() : ""),
      type: "string",
      inFreeText: true,
    },
    {
      label: "Process Status",
      key: "processstatus",
      accessor: (r) => 
        r.processStatus 
          ? `${r.processStatus.active}/${r.processStatus.total}`
          : "",
      type: "string",
      inFreeText: true,
    },
    {
      label: "Ports",
      key: "ports",
      accessor: (r) => (r.ports ? r.ports.toString() : ""),
      type: "string",
      inFreeText: true,
    },
    {
      label: "Date",
      key: "date",
      accessor: (r) => r.date || "",
      type: "string",
      inFreeText: true,
    },
  ];

  // Ensure keys are set
  for (const f of fields) f.key ||= labelId(f.label);
  return fields;
}

